<template>
  <v-card class="complete-register-card" align="center" justify="center" min-width="49vw" max-width="49vw" outlined>
    <div style="width: 100% !important;">
      <v-card-title class="text-center py-1" >
        <v-list-item>
          <v-list-item-title><h2>{{ $t('title_CompleteRegister') }}</h2></v-list-item-title>
        </v-list-item>
      </v-card-title>
      <v-card-text class="justify-center px-7 pb-10" v-if="step === 1">
        <lottie :options="diceLottieOptions" :height="250" :width="250"/>
        <h2>{{ $t('greetings_CompleteRegister', {name: this.$store.state.user.firstName}) }}</h2>
        <p>{{ $t('description_CompleteRegister') }}</p>
        <v-btn @click="goNext">{{ $t('continueBtn') }}</v-btn>
      </v-card-text>
      <v-card-text v-else-if="step === 2" class="pa-5">
        <v-form v-model="valid">
          <v-container fluid>
            <v-row align="center" justify="center">
              <v-col cols="8">
                <v-autocomplete :items="countries" :label="$t('tellUsYourCountry.header')"
                                item-text="name" item-value="name" outlined :rules="countryRule" v-model="country">
                  <template v-slot:selection="data">
                    {{ data.item.name }} <Flag class="ml-2" :code="data.item.code" size="S"/>
                  </template>
                  <template v-slot:item="data">
                    {{ data.item.name }} <Flag class="ml-2" :code="data.item.code" size="S"/>
                  </template>
                </v-autocomplete>
                <v-text-field :label="$t('tellUsYourFirstName.header')" outlined :rules="firstNameRule" v-model="firstName"/>
                <v-text-field :label="$t('tellUsYourLastName.header')" outlined :rules="lastNameRule" v-model="lastName"/>
              </v-col>
            </v-row>
            <v-btn @click="goNext" :disabled="!valid">{{ $t('continueBtn') }}</v-btn>
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-text v-else-if="step === 3" class="pa-5">
        <v-form v-model="valid">
          <v-container fluid>
            <v-row align="center" justify="center">
              <v-col cols="8">
                <v-autocomplete v-if="completedName" :items="countries" :label="$t('tellUsYourCountry.header')"
                                item-text="name" item-value="name" outlined :rules="countryRule" v-model="country">
                  <template v-slot:selection="data">
                    {{ data.item.name }} <Flag class="ml-2" :code="data.item.code" size="S"/>
                  </template>
                  <template v-slot:item="data">
                    {{ data.item.name }} <Flag class="ml-2" :code="data.item.code" size="S"/>
                  </template>
                </v-autocomplete>
                <v-text-field :label="$t('whatIsYourPhoneNumber.header')" outlined :rules="phoneNumberRule" v-model="phoneNumber"/>
                <v-select v-if="!fromMarketingChannel" :items="channels" item-text="text" item-value="value" :rules="channelRule" :label="$t('howMeetUs.header')" outlined v-model="channel"/>
                <v-select class="basic-element" :items="experiences" item-text="text" item-value="value"
                          :label="$t('experience.header')" :rules="experienceRules" v-model="traderExperience" outlined/>
                <v-select :items="traderTypes" item-text="text" item-value="value" :rules="traderTypeRule"
                          :label="$t('whatKindOfTrader.header')" outlined v-model="traderType"/>
              </v-col>
            </v-row>
            <v-btn @click="goBack" v-if="!completedName" class="mr-5">{{ $t('backBtn') }}</v-btn>
            <v-btn @click="submitRegister" :disabled="!valid" :loading="loading">{{ $t('saveBtn') }}</v-btn>
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-text class="justify-center px-7 pb-10" v-if="step === 4">
        <lottie :options="laptopLottieOptions" :height="250" :width="250"/>
        <h2>{{ $t('doneTitle') }}</h2>
        <p >{{ $t('doneDescription') }}</p>
        <v-btn class="button-special" @click="goToJournal">{{ $t('goToJournalBtn') }}</v-btn>
      </v-card-text>
    </div>
  </v-card>
</template>

<script>
import * as diceAnimationData from '@/assets/animations/dice.json';
import * as laptopAnimationData from '@/assets/animations/add-platforms.json';
import CountriesData from './countries';
import axios from 'axios';
import Repository from '../../repositories/auth';
import {mapMutations} from 'vuex';

export default {
  name: "CompleteRegister",
  data() {
    return {
      diceLottieOptions: { animationData: diceAnimationData.default, },
      laptopLottieOptions: { animationData: laptopAnimationData.default, },
      step: 1,
      completedName: true,
      fromMarketingChannel: true,
      firstName: '',
      lastName: '',
      country: '',
      phoneNumber: '',
      traderType: '',
      channel: '',
      brokersSelected: [],
      traderExperience: '',
      loading: false,

      countries: CountriesData,
      channels: [
        { text: 'Instagram', value: 'Instagram'},
        { text: 'Facebook', value: 'Facebook'},
        { text: 'Youtube', value: 'Youtube'},
        { text: 'Webinar', value: 'Webinar'},
        { text: this.$t('channels.wordOfMouth'), value: 'Word-of-Mouth'},
        { text: this.$t('channels.googleSearch'), value: 'Google Search'},
        { text: this.$t('channels.academyPartnership'), value: 'Academy Partnership'},
        { text: this.$t('channels.brokerPartnership'), value: 'Broker Partnership'},
        { text: this.$t('channels.other'), value: 'Other'}
      ],
      traderTypes: [
        {text: 'Swing Trader', value: 'Swing Trader'},
        {text: 'Day Trader', value: 'Day Trader'},
        {text: 'Core Trader', value: 'Core Trader'},
        {text: this.$t('traderTypes.highFrequencyTrader'), value: 'High-Frecuency Trader'},
        {text: this.$t('traderTypes.iDontKnow'), value: 'I don\'t know'},
      ],
      experiences: [
        { text: this.$t('experiences.learning'), value: 'LEARNING' },
        { text: this.$t('experiences.demo'), value: 'TRADING_DEMO' },
        { text: this.$t('experiences.realNoProfit'), value: 'TRADING_REAL_WITHOUT_PROFIT' },
        { text: this.$t('experiences.profitSixMonths'), value: 'PROFIT_LESS_6_MONTHS' },
        { text: this.$t('experiences.profitConsistent'), value: 'PROFIT_MORE_6_MONTHS' },
      ],
      brokers: [],

      // Rules
      valid: false,
      firstNameRule: [
        f => !!f || this.$t('fieldRules.firstName'),
      ],
      lastNameRule: [
        l => !!l || this.$t('fieldRules.lastName'),
      ],
      phoneNumberRule: [
        p => !!p || this.$t('fieldRules.phone'),
      ],
      countryRule: [
        c => !!c || this.$t('fieldRules.country'),
      ],
      channelRule: [
        c => !!c || this.$t('fieldRules.channel'),
      ],
      experienceRules: [
        e => !!e || this.$t('fieldRules.experience'),
      ],
      traderTypeRule: [
        t => !!t || this.$t('fieldRules.traderType'),
      ],
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.completedName = (this.$store.state.user.lastName !== 'NOT REGISTERED');
      this.firstName = this.$store.state.user.firstName;
      this.lastName = (this.completedName)? this.$store.state.user.lastName : '';
      this.fromMarketingChannel = this.$store.state.user.details.channel === "PAID_MARKETING";
      this.channel = (this.fromMarketingChannel)? this.$store.state.user.details.channel : this.channels[0].value;
      this.traderExperience = this.experiences[0].value;
      this.traderType = this.traderTypes[0].value;
    },
    goBack() {
      this.step--;
    },
    goNext() {
      if(this.completedName)
        this.step = 3;
      else
        this.step++;
    },
    async loadBrokers() {
      for (let i = 0; i < 7; i++)
        await axios.get(`${this.$store.state.backend}/brokers?page=${i}`).then(
            (response) => {
              response.data.forEach((item) => {
                this.brokers.push(item);
              });
            }
        );
      this.brokers.sort((one, two) => (one.name > two.name) ? 1 : (one.name < two.name) ? -1 : 0);
    },
    ...mapMutations(['setCompletedRegister']),
    submitRegister() {
      if (this.valid) {
        this.loading = true;

        // For create an array that is expected in backend
        let brokersToRegister = [];
        brokersToRegister.push(this.brokersSelected);

        let userData = {
          userId: this.$store.state.user.id,
          firstName: this.firstName,
          lastName: this.lastName,
          username: this.$store.state.user.username,
          phoneNumber: this.phoneNumber,
          country: this.country,
          brokers: brokersToRegister,
          typeOfTrader: this.traderType,
          previousExperience: this.traderExperience,
          channel: this.channel,
        };

        Repository.completeUserRegister(userData).then((response) => {
          if (response.status < 400 && response.data) {
            this.setCompletedRegister(userData);
            window.sendinblue.identify(this.$store.state.user.email, {
              'NOMBRE': this.firstName,
              'SURNAME': this.lastName,
              'USERNAME': this.$store.state.user.username,
              'PHONE': this.phoneNumber,
              'COUNTRY': this.country,
              'PRO_ON': '0',
              'LANG': this.$i18n.locale,
              'CHANNEL': this.channel,
            });
            window.sendinblue.track('fullRegister');
            window.fbq('track', 'CompleteRegistration');
            this.step = 4;
          }
        });
      } else
        alert(this.$t('alertMessage_CompleteRegister'))
    },
    goToJournal() {
      this.$router.push('/book');
    },
    closeWindow() {
      this.$emit('closeWindow');
    },
  }
}
</script>

<style scoped>

</style>



<style lang="scss">
</style>
